import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from './app/providers/ThemeProvider';
import { AuthProvider } from './app/providers/AuthProvider';
import { SyncProvider } from './app/providers/SyncProvider';
import { AppRouter } from './app/router';
import { UpdatePrompt } from './app/UpdatePrompt';

export function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <SyncProvider>
          <BrowserRouter>
            <AppRouter />
            <UpdatePrompt />
          </BrowserRouter>
        </SyncProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}
